export const OfficeRebDisListState = {
	url: '/rebate-discounts?tab',
	title: 'Office Rebates & Discounts',
	template: '<rebates-discounts-page></rebates-discounts-page>',
	params: {tab: {value: null, dynamic: true}},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeDiscountAndRebatesPageMod" */
			'@Containers/office-rebate-discounts-page/office-rebates-discounts-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
